import { render, staticRenderFns } from "./ShippingDetail.vue?vue&type=template&id=965f3b80&"
import script from "./ShippingDetail.vue?vue&type=script&lang=ts&"
export * from "./ShippingDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports